<template>
  <gv-modal-offscreen
    aria-labelledby="mep-hero-header-text"
    data-theme="mobile"
    :modal="modal"
    :min-height="700"
    :width="tw`w-full xs:w-[480px] sm:w-[640px] md:w-[720px] lg:w-[960px]`"
    :fullscreen="fullscreen.value"
    layout="flex-col"
    :close-on-click-outside="false"
    :border-radius="tw`rounded-[32px]`"
    backdrop="heavy"
    background="transparent"
  >
    <!-- We define custom headers (and footers) in the body -->
    <template #header>
      <!-- Override the default header slot -->
      <div></div>
    </template>

    <suspense>
      <async-ui-my-emergency-plan-modal-body />
      <template #fallback>
        <div class="flex grow items-center justify-center self-stretch">
          <ui-spinner size="sm" tabindex="0" aria-label="Loading" />
        </div>
      </template>
    </suspense>
  </gv-modal-offscreen>
</template>

<script lang="ts" setup>
import { computed, defineAsyncComponent, inject } from 'vue';
import * as Symbols from '@/common/constants/symbols';
import { tw } from '@/common';
import { useBreakpoints } from '@vueuse/core';
import { BREAKPOINTS } from '@/constants';

const breakpoints = useBreakpoints(BREAKPOINTS);
const fullscreen = computed(() => breakpoints.smaller('xs'));

const { modal } = {
  modal: inject(Symbols.MyEmergencyPlanModal)!,
};

const AsyncUiMyEmergencyPlanModalBody = defineAsyncComponent(
  () => import('@/features/my-emergency-plan/presentation/components/UiMyEmergencyPlanModalBody.vue')
);
</script>
